import { render, staticRenderFns } from "./MessageTypeForward.vue?vue&type=template&id=429c1906&scoped=true&"
import script from "./MessageTypeForward.vue?vue&type=script&lang=js&"
export * from "./MessageTypeForward.vue?vue&type=script&lang=js&"
import style0 from "./MessageTypeForward.vue?vue&type=style&index=0&id=429c1906&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "429c1906",
  null
  
)

export default component.exports